module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a6-11-5f9839fea0c1940dd9510b04a8b6aad9.jpg";